import { meetingRechedule } from "../helpers/helpers";
import {
  formatSentence,
  isStringEqualTo,
  textWithFirstCharUpper,
  textWithOnlyUpper,
} from "../helpers/string";
import { Constants } from "../utils/constants";
import { getDateForInput } from "../utils/date";
import { api } from "./api";
import { GuestApiAuthenticated } from "./GuestApiAuthenticated";

export const submitOnboardingForm = async (formData) => {
  const selectedDomains = formData.domains.map((d) => {
    return {
      domainId: d.id,
      domainName: d.name,
      services: d.subCategory.map((sub) => {
        return {
          serviceId: sub.id,
          serviceName: sub.name,
        };
      }),
    };
  });
  let documents = Object.assign(
    {},
    ...formData.documents.map((doc) => {
      return {
        [doc.id]: doc.docId,
      };
    }),
  );

  const additonalDoc = formData.additionalDocuments.map((doc) => {
    return {
      fileName: doc.name,
      fileEntryId: doc.docId,
    };
  });

  return GuestApiAuthenticated.post(
    Constants.URL.submitForm,
    JSON.stringify({
      additionalDocuments: additonalDoc,
      address: textWithFirstCharUpper(formData.address),
      area: textWithFirstCharUpper(formData.area),
      domains: selectedDomains,
      emailAddress: formData.emailAddress,
      mobileNo: formData.mobileNumber,
      nameOfApplicantFirm: textWithFirstCharUpper(formData.nameOfApplicantFirm),
      numberOfEmployees: formData.numberOfEmployees,
      officeTelephone: formData.officeTelephone,
      primaryContactDesignation: textWithFirstCharUpper(
        formData.primaryContactDesignation,
      ),
      primaryContactEmailAddress: formData.primaryContactEmail,
      mSARequestedBy: textWithFirstCharUpper(formData.mSARequestedBy),
      primaryContactName: textWithFirstCharUpper(formData.primaryContactName),
      primaryContactPhoneNumber: formData.primaryContactPhone,
      townOrCity: textWithFirstCharUpper(formData.city),
      tradeLicenseNumber: textWithOnlyUpper(formData.tradeLicence),
      turnoverLastYearinAED: formData.lastYearTurnover,
      vATRegistrationNumber: textWithOnlyUpper(formData.vatRegistration),
      yearOfEstablishment: formData.yearOfEstablishment,
      ...documents,
    }),
    {
      headers: {
        "content-type": "application/json",
      },
    },
  ).catch((e) => console.debug(e));
};

export const getApplicationsList = async () => {
  return api.get(Constants.URL.getApplications).catch((e) => console.debug(e));
};

export const retrievePartnerOnboardingId = async (emailAddress) => {

  return api
    .get(
      `/o/c/partneronboardings?filter=primaryContactEmail eq '${emailAddress}'`,
    )
    .catch((e) => console.debug(e));
};

export const getErrorMessage = (field) => {
  switch (field.id) {
    case "vateRegistration":
      return "Please enter VAT registration number.";
    case "tradeLicence":
      return "Please enter Trade license number.";
    default:
      return `${field.value == "Select" ? "Please select" : "Please enter"} ${field.ariaValueNow}.`;
  }
};
export const getApplicationsListByStatus = async (status, pageSize, pageNo) => {
  const query = encodeURI(
    `?filter=applicationStatus eq '${status}'&pageSize=${pageSize}&page=${pageNo}&fields=id,nameOfApplicantFirm,primaryContactName,primaryContactEmail,emailAddress,dateCreated,isAudit&restrictFields=actions&sort=dateCreated:desc`,
  );

  return api
    .get(Constants.URL.getApplications + query)
    .catch((e) => console.debug(e));
};

export const additionalDocsService = async (externalReferenceCode, docId) => {
  return api
    .put(
      Constants.URL.additionaldocuments +
        "/by-external-reference-code/" +
        externalReferenceCode,
      JSON.stringify({
        document: String(docId),
      }),
      {
        headers: {
          "content-type": "application/json",
        },
      },
    )
    .catch((e) => console.debug(e));
};

export const newExtraDocService = (payload) => {
  return api.post(Constants.URL.additionaldocuments, JSON.stringify(payload), {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const hasMatchingIds = (selectedServices, auditServices) => {

  const KEY_WORDS = ["Audit", "Services"];
  let isMatched = false;
  let services = [];
  for (let i = 0; selectedServices.length > i; i++) {
    services = [...services, ...selectedServices[i].subCategory];
  }

  for (let i = 0; services.length > i; i++) {
  
    if (
      services[i].name.includes(KEY_WORDS[0]) &&
      services[i].name.includes(KEY_WORDS[1])
    ) {
      isMatched = true;
    }
  }

  return isMatched;

  return selectedServices?.some((domain) =>
    domain.subCategory?.some((sub) =>
      auditServices?.some((auditService) => sub.id === auditService.id),
    ),
  );
};
